import { PaymentProvider } from "../../enums/payment-provider-enum";
import { PaymentType } from "../../enums/payment-type-enum";
import { BaseModel } from "../base.model";

export class PaymentModel extends BaseModel {
    token?: string;
    amount?: number; 
    currency?: string;
    sourceNumber?: string;
    sourceId?: string; 
    userId?: string; 
    transactionId?: string; 
    receiptUrl?: string; 
    status?: string; 
    description?: string; 
    paymentType?: PaymentType; 
    invoiceId?: string; 
    refundPaymentIds?: string[];
    provider?: PaymentProvider;
}
